/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentBeschreibungRequest { 
    beschreibung?: string;
    ort?: string;
    titel: string;
    veranstaltung_id?: string;
    bilder_upload_ids?: Array<string>;
    incident_id: string;
}

